// Use this, not the one in library-core
export enum Themes  {
  warning = "warning",
  error = "error",
  success = "success",
  warningAlt = "warning-alt",
  errorAlt = "error-alt",
  successAlt = "success-alt",
  info = "info",
  infoBlue = "info-blue",
  infoAlt = "info-alt",
}
